import React from 'react'

export type BadgeTone = 'neutral' | 'signal' | 'active' | 'muted'

/**
 * Small tag, used for status labels like "Aktuel" / "Historisk" / role
 * names. Color is conveyed via a small set of semantic tones rather than
 * raw Tailwind classes so the visual language stays coherent.
 */
interface BadgeProps {
  tone?: BadgeTone
  children: React.ReactNode
  title?: string
  className?: string
}

const TONE_CLASSES: Record<BadgeTone, string> = {
  neutral: 'bg-rule-soft text-ink-700',
  signal: 'bg-signal-50 text-signal-700',
  active: 'bg-active-50 text-active-700',
  muted: 'bg-rule-soft text-ink-500',
}

const Badge: React.FC<BadgeProps> = ({
  tone = 'neutral',
  children,
  title,
  className = '',
}) => {
  return (
    <span
      title={title}
      className={`inline-flex items-center gap-1.5 px-2 py-[3px] text-xs font-semibold rounded-[4px] whitespace-nowrap ${TONE_CLASSES[tone]} ${className}`}
    >
      {children}
    </span>
  )
}

export default Badge
